/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LegalDocumentsQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type LegalDocumentsQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly customTermsOfUseAgreement: string | null } | null };


export const LegalDocumentsDocument = gql`
    query LegalDocuments($accountId: AccountId!) {
  account(id: $accountId) {
    id
    customTermsOfUseAgreement
  }
}
    `;

/**
 * __useLegalDocumentsQuery__
 *
 * To run a query within a React component, call `useLegalDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalDocumentsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useLegalDocumentsQuery(baseOptions: Apollo.QueryHookOptions<LegalDocumentsQuery, LegalDocumentsQueryVariables> & ({ variables: LegalDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegalDocumentsQuery, LegalDocumentsQueryVariables>(LegalDocumentsDocument, options);
      }
export function useLegalDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegalDocumentsQuery, LegalDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegalDocumentsQuery, LegalDocumentsQueryVariables>(LegalDocumentsDocument, options);
        }
export function useLegalDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LegalDocumentsQuery, LegalDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LegalDocumentsQuery, LegalDocumentsQueryVariables>(LegalDocumentsDocument, options);
        }
export type LegalDocumentsQueryHookResult = ReturnType<typeof useLegalDocumentsQuery>;
export type LegalDocumentsLazyQueryHookResult = ReturnType<typeof useLegalDocumentsLazyQuery>;
export type LegalDocumentsSuspenseQueryHookResult = ReturnType<typeof useLegalDocumentsSuspenseQuery>;
export type LegalDocumentsQueryResult = Apollo.QueryResult<LegalDocumentsQuery, LegalDocumentsQueryVariables>;